<template>
  <div v-if="checklists.length > 0" data-testid="overview-checklists">
    <SfList no-margin>
      <SfListItem
        v-for="checklist in checklists"
        :key="checklist.id"
        :item-id="String(checklist.id)"
        :selected="isActive(checklist)"
        variant="md"
        cornered
        :content-extra-classes="['tw-pl-1.5', 'tw-min-w-0']"
        :href="checklist.path"
        @item-click="onClick(checklist)"
      >
        <template #icon>
          <i class="fa fa-list-check" aria-hidden="true" />
        </template>
        <SfTruncatedLabel :text="checklist.name" />
      </SfListItem>
    </SfList>
    <hr
      class="
        tw-my-2
        tw-border-solid
        tw-border-x-0
        tw-border-t-0
        tw-border-b
        tw-border-sf-slate-lighter-1
      "
      data-testid="overview-checklists-divider-bottom"
    />
  </div>
</template>

<script setup lang="ts">
import type { OverviewChecklist } from '../types'

import SfList from '@app/shared/vue/components/sf-list/sf-list.vue'
import SfListItem from '@app/shared/vue/components/sf-list/sf-list-item.vue'
import SfTruncatedLabel from '@app/shared/vue/components/sf-truncated-label.vue'

defineOptions({
  name: 'OverviewNavigationChecklists',
})

interface Props {
  checklists: OverviewChecklist[]
  currentPath: string
}

const props = defineProps<Props>()

function isActive(checklist: OverviewChecklist): boolean {
  return props.currentPath === checklist.path
}

function onClick(checklist: OverviewChecklist): void {
  window.Turbolinks.visit(checklist.path)
}
</script>
